import { pick } from "../../util/object";
import { $httpAdmin, $httpAdminSync } from "../../api/http";
import { type AxiosPromise } from "../../modules/axios";

export interface Application {
  id: number;
  sort: number;
  title: string;
  content: string;
}

export function apiApplicationGet(): AxiosPromise<Application[]> {
  return $httpAdmin.get('/title/mtyylyselect');
}

export async function apiApplicationAdd(params: Omit<Application, 'id'>): Promise<AxiosPromise> {
  await $httpAdminSync.post('/title/mtyylyadd', params);
  return $httpAdmin.post('/title/mtyylyadd', params);
}

export async function apiApplicationUpdate(params: Partial<Application>): Promise<AxiosPromise> {
  await $httpAdminSync.patch('/title/mtyylyupdate', pick(params, ['id', 'content']));
  return $httpAdmin.patch('/title/mtyylyupdate', params);
}

export async function apiApplicationDelete(id: Application['id']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/title/mtyylydeletebyid/${id}`);
  return $httpAdmin.delete(`/title/mtyylydeletebyid/${id}`);
}
